import WebSocket from 'ws';
import { sendWsMessage } from '../../connection/create-ws-bridge.js';
import type { CliE2eeRuntime } from '../../lib/e2ee/index.js';
import type { GitBranchScope } from './resolve-git-branch-scope.js';
import type { FileBrowserRequestMessage } from './types.js';
import { executeFileBrowserRead } from './execute-file-browser-read.js';
import { sendFileBrowserMessage } from './send-file-browser-message.js';

export async function handleFileBrowserRead(
  socket: WebSocket,
  e2ee: CliE2eeRuntime | undefined,
  msg: FileBrowserRequestMessage,
  reqPath: string,
  sessionParentPath: string | undefined,
  gitScope: GitBranchScope | null,
): Promise<void> {
  const result = await executeFileBrowserRead({ msg, reqPath, sessionParentPath, gitScope });

  if ('error' in result) {
    sendWsMessage(socket, { type: 'file_browser_response', id: msg.id, error: result.error });
    return;
  }

  const payload: Record<string, unknown> = {
    type: 'file_browser_response',
    id: msg.id,
    content: result.content,
    totalLines: result.totalLines,
    size: result.size,
  };
  if (result.lineOffset != null) payload.lineOffset = result.lineOffset;
  if (result.mimeType != null) payload.mimeType = result.mimeType;
  if (result.resolvedPath != null) payload.resolvedPath = result.resolvedPath;

  sendFileBrowserMessage(socket, e2ee, payload);
}
